module.exports = __webpack_public_path__ + "img/3-1.5c384f6d.png";